import { Shuffle } from "lucide-react";

import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";

import { Input } from "shared/components/inputs/Input";

import { ICupom } from "shared/interfaces/ICupom";

import {
  criarNovoCupom,
} from "../../shared/services/api/cupons.api";

import { api } from "../../shared/services/api";

import styles from "./CdCupom.module.scss";

export const CdCupom = () => {
  const {
    register,
    setValue,
    handleSubmit,
    watch,
  } = useForm<ICupom>();

  const [categorias, setCategorias] = useState<any[]>([]);

  const discountType = watch("discountType");

  const gerarCodigo = () => {
    const codigo = Math.random()
      .toString(36)
      .substring(2, 10)
      .toUpperCase();

    setValue("code", codigo);
  };

  const onSubmit = async (data: ICupom) => {
    try {
      await criarNovoCupom({
        ...data,
        discountValue: Number(data.discountValue),
        maxUses: Number(data.maxUses),
      });

      alert("Cupom criado com sucesso");
    } catch (error: any) {
      console.error(error);
      console.error(error?.response?.data);

      alert(
        error?.response?.data?.message ||
          error?.message ||
          "Erro ao criar cupom",
      );
    }
  };

  useEffect(() => {
    async function carregarCategorias() {
      try {
        const response = await api.get("/categories");

        setCategorias(response.data || []);
      } catch (error) {
        console.error(error);
      }
    }

    carregarCategorias();
  }, []);

  return (
    <div className={styles.page}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={styles.card}
      >
        {/* CÓDIGO */}

        <div className={styles.containerInput}>
          <div className={styles.containerLabel}>
            <label className={styles.label}>
              Código do Cupom
            </label>

            <button
              type="button"
              className={styles.generate}
              onClick={gerarCodigo}
            >
              <Shuffle size={14} />
              Gerar código aleatório
            </button>
          </div>

          <Input
            type="text"
            name="code"
            placeholder="Ex: BLACK10"
            register={register}
            customClass={styles.customInput}
          />
        </div>

        {/* DESCONTO */}

        <div className={styles.containerInput}>
          <label className={styles.label}>
            Desconto
          </label>

          <div className={styles.descontoContainer}>
            <input
              type="number"
              placeholder="Ex: 25"
              className={styles.inputDesconto}
              {...register("discountValue", {
                valueAsNumber: true,
              })}
            />

            <button
              type="button"
              className={`${styles.btnTipo} ${
                discountType === "PERCENTAGE"
                  ? styles.ativo
                  : ""
              }`}
              onClick={() =>
                setValue(
                  "discountType",
                  "PERCENTAGE",
                )
              }
            >
              %
            </button>

            <button
              type="button"
              className={`${styles.btnTipo} ${
                discountType === "FIXED"
                  ? styles.ativo
                  : ""
              }`}
              onClick={() =>
                setValue(
                  "discountType",
                  "FIXED",
                )
              }
            >
              R$
            </button>
          </div>
        </div>

        {/* TÉRMINO */}

        <div className={styles.containerDates}>
          <div className={styles.containerDate}>
            <label className={styles.label}>
              Término
            </label>

            <input
              type="datetime-local"
              {...register("expiresAt")}
            />
          </div>
        </div>

        {/* LIMITE DE USOS */}

        <div className={styles.containerInput}>
          <label className={styles.label}>
            Limite de utilizações
          </label>

          <Input
            type="number"
            name="maxUses"
            placeholder="Ex: 100"
            register={register}
            customClass={styles.customInput}
          />
        </div>

        {/* CATEGORIA */}

        <div className={styles.containerInput}>
          <label className={styles.label}>
            Categoria
          </label>

          <select
            {...register("categoryId")}
            className={styles.select}
          >
            <option value="">
              Selecione a categoria
            </option>

            {categorias.map((categoria) => (
              <option
                key={categoria.id}
                value={categoria.id}
              >
                {categoria.nome}
              </option>
            ))}
          </select>
        </div>

        {/* SALVAR */}

        <button
          type="submit"
          className={styles.salvar}
        >
          Salvar
        </button>
      </form>
    </div>
  );
};